<template>
<div class='b-page-wrapper b-page-wrapper--gray h-flex h-flex-center'>
    <FwPopup
        :centered='true'
        :isFixed='true'
        :max-width='isDesktop() ? "450px" : "calc(100% - 20px)"'
        width='90%'
        popupClass='b-popup-style'
        :allowBackgroundScrolling='true'
        :disableClosingOnClickOutside='true'
        popupBackground='#FFFFFF'
        popupRadius='20px'>
        <template #header>
            <div class='h-text-center h-mb-20'>
                <div class='b-base-title h-mt-10'>
                    {{ $t('LOGIN.TXT') }}
                </div>
            </div>
        </template>
        <template #body>
            <div class='h-mt-15' @keyup.enter='addCompanyNameToState'>
                <FwFormInput
                    class='h-mb-30 qa-company-input-wrapper'
                    :fieldHasError='fieldHasErrorByRule(company_name, "company_name", companyNameRules)'
                    labelType='label-thin'
                    :title='$t(`LOGIN.COMPANY.LABEL`)'>
                    <FwInput
                        v-focus='true'
                        :value='company_name'
                        type='text'
                        name='text'
                        inputStyle='gray'
                        :placeholder='$t(`LOGIN.COMPANY.PLACEHOLDER`)'
                        :error='getFieldErrorTextByRule(company_name, "company_name", companyNameRules)'
                        @update='value => company_name = value'
                        @blur='addCurrentInputToValidateArray("company_name")'>
                    </FwInput>
                </FwFormInput>
                <div class='h-flex h-flex-center h-width-100p h-pt-10'>
                    <FwButton
                        :disabled='!isFormValid'
                        class='qa-company-submit'
                        borderRadiusType='small-border'
                        @click='addCompanyNameToState'>
                        {{ $t('BUTTON.NEXT') }}
                    </FwButton>
                </div>
            </div>
        </template>
    </FwPopup>
</div>
</template>

<script lang='ts'>
import { Component, mixins, Vue } from 'vue-facing-decorator';
import { ChooseSiteLang } from '@/components/global/ChooseSiteLang';
import { useValidation } from '@/composables/useValidation';
import RedirectMixin from '@/mixins/redirect';
import AuthMixin from '@/mixins/auth';
import { useUserStore } from '@/stores/useUserStore';

@Component({
    components: {
        ChooseSiteLang,
    },
})
export default class LoginCompanyPage extends mixins(RedirectMixin, AuthMixin) {
    company_name: string = '';
    globalServerError: string = '';
    companyNameRules: string[] = ['required', 'minLength:2', 'maxLength:100'];

    validation = useValidation();

    get fieldHasErrorByRule() {
        return this.validation.fieldHasErrorByRule;
    }

    get getFieldErrorTextByRule() {
        return this.validation.getFieldErrorTextByRule;
    }

    get clearServerErrorsBase() {
        return this.validation.clearServerErrorsBase;
    }

    get addCurrentInputToValidateArray() {
        return this.validation.addCurrentInputToValidateArray;
    }

    get isFormValid() {
        return this.validation.baseInputValidator({ value: this.company_name });
    }

    addCompanyNameToState() {
        if (this.isFormValid) {
            const userStore = useUserStore();
            userStore.COMPANY_NAME(this.company_name);
            this.$router.push({ path: '/login' });
        }
    }
}
</script>

<style lang='sass'>
.b-login-choose-site-lang
    position: fixed
    right: 50px
    top: 50px
    z-index: 14
    @include media('<=phone')
        position: static
        margin: 30px 0

.b-login-page
    &__forget-password
        position: absolute
        right: 0
        height: 0
        color: #27DBBD
        &__wrapper
            position: relative
            width: 100%
            display: flex
            align-items: center
            justify-content: flex-end
            height: 0
</style>
